export interface LiveRoom {
  id: number;
  title: string;
  host: string;
  viewers: string;
  tag: string;
  category: string;
}

export interface HotItem {
  rank: number;
  title: string;
  heat: string;
  delta: 'up' | 'down' | 'new' | 'flat';
  tag: string;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  desc: string;
  count: number;
}

export interface FeedCard {
  id: number;
  category: string;
  title: string;
  summary: string;
  read: string;
  time: string;
  hot: string;
  image: string;
  cover: string;
}

export interface Step {
  icon: string;
  title: string;
  desc: string;
}

export interface Praise {
  name: string;
  role: string;
  text: string;
  star: number;
}

export interface Faq {
  q: string;
  a: string;
}

export const liveRooms: LiveRoom[] = [
  { id: 1, title: '顶流剧组拍摄现场直击', host: '前线酱酱', viewers: '3.2万围观', tag: 'LIVE', category: '剧组内幕' },
  { id: 2, title: '选秀落幕夜的弹幕名场面', host: '吃瓜不停机', viewers: '8.6万围观', tag: 'LIVE', category: '综艺现场' },
  { id: 3, title: '年度红毯造型逐帧拆解', host: '时尚放大镜', viewers: '1.9万围观', tag: 'LIVE', category: '时尚八卦' },
  { id: 4, title: '音乐节后台连麦解压局', host: '音浪观察员', viewers: '5400围观', tag: 'LIVE', category: '音乐圈' },
  { id: 5, title: '塌房复盘：一条动态引发的', host: '真相侦察员', viewers: '2.3万围观', tag: 'LIVE', category: '网红风向' },
  { id: 6, title: '古装剧组群演的一天', host: '横店小喇叭', viewers: '1.1万围观', tag: 'LIVE', category: '剧组内幕' },
];

export const hotList: HotItem[] = [
  { rank: 1, title: '新晋视后获奖感言泪洒现场，一句“感谢自己”引爆弹幕', heat: '386万热度', delta: 'up', tag: '爆' },
  { rank: 2, title: '跨年晚会对嘴疑云：业内爆料现场音准零误差的真相', heat: '312万热度', delta: 'up', tag: '热' },
  { rank: 3, title: '综艺导演空降问答：那些“剧本”其实比想象中更真实', heat: '258万热度', delta: 'new', tag: '爆' },
  { rank: 4, title: '红毯名场面盘点：谁的造型让时尚博主集体起立鼓掌', heat: '197万热度', delta: 'flat', tag: '热' },
  { rank: 5, title: '塌房预警？顶流演唱会门票秒罄背后的黄牛产业链', heat: '163万热度', delta: 'down', tag: '探' },
  { rank: 6, title: '选秀导师被考古：十年前的一个采访片段翻红全网', heat: '128万热度', delta: 'up', tag: '忆' },
  { rank: 7, title: '剧组路透流出：男女主对手戏NG三十条为哪般', heat: '96万热度', delta: 'down', tag: '探' },
  { rank: 8, title: '音乐节档期撞车，粉丝站子发布联合声明闹出大新闻', heat: '74万热度', delta: 'new', tag: '热' },
];

export const categories: Category[] = [
  { id: 'star', name: '明星绯闻', icon: 'ri-star-smile-fill', desc: '一线动态、恋爱实锤、分手反转', count: 328 },
  { id: 'variety', name: '综艺名场面', icon: 'ri-clapperboard-fill', desc: '抓马瞬间、导师名句、站姐手记', count: 196 },
  { id: 'crew', name: '剧组内幕', icon: 'ri-film-fill', desc: '路透直击、选角花絮、片场秘辛', count: 154 },
  { id: 'netstar', name: '网红塌房', icon: 'ri-flashlight-fill', desc: '翻车现场、人设崩塌、电商八卦', count: 121 },
  { id: 'live', name: '现场直击', icon: 'ri-camera-3-fill', desc: '红毯首映、音乐节、颁奖礼', count: 243 },
  { id: 'music', name: '音乐圈', icon: 'ri-music-2-fill', desc: '新歌战报、巡演动态、乐坛秘辛', count: 87 },
];

export const feedCards: FeedCard[] = [
  {
    id: 1,
    category: '现场直击',
    title: '首映礼红毯全景回放：谁的走位最吸睛，谁在暗处悄悄营业',
    summary: '镜头扫过的每一帧都藏着信息量，我们从站位、眼神到互动细节逐一拆解这场红毯名场面。',
    read: '6.8万阅读',
    time: '12分钟前',
    hot: '热议',
    image: 'https://readdy.ai/api/search-image?query=crowded%20red%20carpet%20movie%20premiere%20with%20bright%20stage%20lights%2C%20celebrities%20and%20flash%20cameras%2C%20glamorous%20warm%20golden%20bokeh%20background%2C%20editorial%20entertainment%20photography&width=760&height=520&seq=feed-01&orientation=landscape',
    cover: 'feed-01',
  },
  {
    id: 2,
    category: '综艺现场',
    title: '一档户外综艺的抓马幕后：嘉宾之间真有“剧本冲突”吗？',
    summary: '节目组亲述剪辑逻辑，原来观众看到的“针锋相对”背后藏着数小时的素材与镜头语言。',
    read: '4.2万阅读',
    time: '38分钟前',
    hot: '热议',
    image: 'https://readdy.ai/api/search-image?query=outdoor%20variety%20show%20filming%20set%20with%20cameras%20and%20crew%2C%20stage%20props%20and%20colorful%20lights%20at%20dusk%2C%20behind%20the%20scenes%2C%20editorial%20style&width=760&height=520&seq=feed-02&orientation=landscape',
    cover: 'feed-02',
  },
  {
    id: 3,
    category: '剧组内幕',
    title: '古装大戏开播前，服化道组爆料主角那件“天价戏服”',
    summary: '从刺绣针脚到面料采购，一件戏服背后是一整个剧组连续数月的精益求精与预算拉扯。',
    read: '3.6万阅读',
    time: '1小时前',
    hot: '热播',
    image: 'https://readdy.ai/api/search-image?query=elaborate%20traditional%20chinese%20costume%20detail%20with%20intricate%20embroidery%20and%20gold%20thread%20on%20velvet%2C%20movie%20set%20background%2C%20warm%20studio%20lighting&width=760&height=520&seq=feed-03&orientation=landscape',
    cover: 'feed-03',
  },
  {
    id: 4,
    category: '明星绯闻',
    title: '恋情疑云升级：同款配饰频繁撞车，是真爱还是营业合作？',
    summary: '我们用时间线把同款出现的每个节点串起来，网友吵翻天的答案其实早就写在细节里。',
    read: '9.1万阅读',
    time: '2小时前',
    hot: '爆',
    image: 'https://readdy.ai/api/search-image?query=romantic%20moody%20city%20night%20scene%20with%20soft%20neon%20lights%20and%20silhouette%20of%20couple%2C%20mysterious%20atmosphere%2C%20cinematic%20entertainment%20style&width=760&height=520&seq=feed-04&orientation=landscape',
    cover: 'feed-04',
  },
  {
    id: 5,
    category: '网红风向',
    title: '头部博主停更一周背后：品牌解约潮如何改变人设走向',
    summary: '一条停更声明引发的行业震荡，广告主、MCN与创作者的三方博弈全梳理。',
    read: '2.8万阅读',
    time: '3小时前',
    hot: '热议',
    image: 'https://readdy.ai/api/search-image?query=influencer%20smartphone%20studio%20with%20ring%20light%20and%20green%20screen%20setup%2C%20modern%20minimal%20workspace%2C%20soft%20warm%20lighting%2C%20editorial&width=760&height=520&seq=feed-05&orientation=landscape',
    cover: 'feed-05',
  },
  {
    id: 6,
    category: '音乐圈',
    title: '新专辑上线即登顶：制作人揭秘这张专辑背后的“极简野心”',
    summary: '从采样到混音，制作人带着我们听完每一轨，看懂音乐市场审美的又一次转向。',
    read: '1.9万阅读',
    time: '5小时前',
    hot: '热播',
    image: 'https://readdy.ai/api/search-image?query=recording%20studio%20with%20vintage%20mixing%20console%20and%20microphone%2C%20warm%20ambient%20light%20and%20vinyl%20records%2C%20music%20editorial%20photography&width=760&height=520&seq=feed-06&orientation=landscape',
    cover: 'feed-06',
  },
  {
    id: 7,
    category: '时尚八卦',
    title: '红毯翻车与封神之间，明星造型团队都在赌什么？',
    summary: '独家采访两位造型师，聊聊那些“冲上热搜”的造型决策到底有多少试错成本。',
    read: '5.4万阅读',
    time: '6小时前',
    hot: '热议',
    image: 'https://readdy.ai/api/search-image?query=fashion%20designer%20studio%20with%20couture%20dresses%20on%20mannequins%20and%20fabric%20swatches%2C%20warm%20editorial%20lighting%2C%20glamorous%20behind%20the%20scenes&width=760&height=520&seq=feed-07&orientation=landscape',
    cover: 'feed-07',
  },
  {
    id: 8,
    category: '影视战报',
    title: '春节档排片大战：谁在偷师谁？院线经理说出了真话',
    summary: '从预售数据到排片策略，我们用一张时间表看懂电影市场每个环节的明争暗斗。',
    read: '7.7万阅读',
    time: '8小时前',
    hot: '热播',
    image: 'https://readdy.ai/api/search-image?query=cinema%20theater%20lobby%20with%20movie%20posters%20and%20concession%20stand%2C%20warm%20glowing%20lights%2C%20crowded%20atmosphere%2C%20editorial&width=760&height=520&seq=feed-08&orientation=landscape',
    cover: 'feed-08',
  },
];

export const steps: Step[] = [
  { icon: 'ri-scan-2-line', title: '全网线索捕捉', desc: '舆情雷达 7×24 小时扫描热搜、路透与爆料区，第一时间发现可吃好瓜。' },
  { icon: 'ri-stack-line', title: '多方交叉核实', desc: '同一个瓜，我们会翻遍现场、目击与当事人回应，层层比对后才呈现给你。' },
  { icon: 'ri-live-line', title: '直播同步围观', desc: '进入滚动的在线瓜场，进度条与弹幕实时推进，全程不让你错过任何一帧。' },
  { icon: 'ri-chat-3-line', title: '弹幕一起开撕', desc: '开麦讨论、站队表态、复盘细节，让每次吃瓜都变成一场集体的脑补狂欢。' },
];

export const praises: Praise[] = [
  { name: '苏打不冒泡', role: '追星女孩 · 深蹲粉', star: 5, text: '爆瓜台的现场直击是真·现场，很多热搜第一眼还没上，这里已经开播复盘了，速度绝了。' },
  { name: '老周不熬夜', role: '综艺老粉', star: 5, text: '喜欢他们把“名场面”拆得明明白白，既有梗又不乱带节奏，是我看综艺的上头搭子。' },
  { name: 'Linlin_66', role: '吃瓜路人', star: 5, text: '弹幕氛围太好了，大家素质在线又有趣，跟着一起分析线索真的会上瘾。' },
  { name: 'Vita想退休', role: '影视行业从业者', star: 5, text: '剧组内幕和排片那些选题很专业，看得出下了功夫，行业人看了也服气。' },
];

export const faqs: Faq[] = [
  { q: '爆瓜台的“直播爆料”和普通图文新闻有什么不同？', a: '爆瓜台的核心是“在线瓜场”。一个瓜爆出后，主播会立刻开启直播，带着滚动的时间线、路透图和弹幕一起实时复盘，你可以边看边刷进度条，也可以随时开麦发表看法，真正做到“不用等明天，爆料到达端口即用”。' },
  { q: '瓜的信息来源可靠吗？会不会吃到假瓜？', a: '我们坚持“多方交叉核实”的内容原则：每一个进入直播的瓜都要经过线索捕捉、现场比对和多方回应三个阶段。标注“LIVE”的为实时跟进现场，标注“复盘”的为已经过多方信息交叉确认的总结，尽可能降低吃假瓜的风险。' },
  { q: '围观直播需要付费吗？', a: '绝大多数吃瓜直播间完全免费，直接点开即可进入围观和参与弹幕。仅有极少数制作投入特别大的“幕后探访”专题需要解锁，我们会在卡片上清晰标注，绝不搞诱导付费。' },
  { q: '我发现了新鲜瓜，该怎么向爆瓜台爆料？', a: '你可以在每个直播间的“爆料入口”提交线索，或通过页尾的联系方式发给我们。被采纳的线索会进入核实流程，一经采用我们会第一时间回访你，并在直播中致谢。' },
  { q: '爆瓜台会对明星造成伤害吗？', a: '爆瓜台定位是“有边界的娱乐围观”。我们聚焦台前作品、名场面与公开信息，不做人肉搜索、不传播无依据的隐私与谣言。若你发现内容有误，可通过页尾反馈入口一键纠错。' },
];

export const stats = [
  { value: '1200+', label: '累计吃瓜直播场次' },
  { value: '5000万+', label: '全网弹幕围观人次' },
  { value: '300+', label: '追线记者与爆料站主' },
  { value: '99.2%', label: '现场直击准时开播率' },
];